export default __webpack_public_path__ + "static/media/box-bg.ad321296.svg";